export const iconFontAwesomeHumanitarianTruckField = (
	<i className="fa-solid fa-truck-field"></i>
);
